export default "__VITE_ASSET__buki4yWu__"